var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _ellipse, _path46, _ellipse2, _ellipse3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtc04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.189453,
    y: 0.707031,
    width: 350,
    height: 233,
    fill: "#44976F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.366 187.266C216.7 191.552 225.411 192.211 230.942 192.211C235.552 191.95 237.237 189.742 237.082 188.785C236.8 187.048 237.411 185.964 235.013 183.36C232.615 180.755 218.641 171.856 211.863 168.926C205.085 165.995 197.675 164.734 194.866 167.515C192.917 169.444 193.297 172.773 194.866 175.755C196.083 178.071 201.256 183.609 208.366 187.266Z",
    fill: "#0F0D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.62 151.021C270.064 157.482 278.625 156.915 282.298 156.915C288.535 156.723 290.595 153.94 290.451 153.103C290.19 151.584 290.757 150.637 288.535 148.359C286.312 146.082 273.365 138.3 267.085 135.738L267.057 135.726C260.78 133.165 252.355 129.728 249.756 132.156C247.95 133.843 248.762 139.048 250.216 141.656C251.669 144.263 253.401 147.174 259.62 151.021Z",
    fill: "#0F0D22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.833 146.172C178.527 144.404 177.004 140.754 177.004 137.405C177.18 132.793 178.395 135.769 179.316 135.769C180.237 135.769 182.351 139.607 182.965 142.848C183.579 146.088 198.173 161.807 186.28 153.004C183.186 150.713 181.119 147.914 179.851 146.196L179.833 146.172Z",
    fill: "#0F0D22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 167.793L208.912 163.164L210.728 164.45C211.78 165.194 211.924 166.271 211.279 167.182C210.625 168.106 209.561 168.308 208.493 167.552L207.662 166.963L206.594 168.472L205.635 167.793ZM208.21 166.19L208.887 166.669C209.457 167.072 209.961 166.95 210.288 166.481C210.617 166.023 210.559 165.516 209.992 165.109L209.314 164.63L208.21 166.19Z",
    fill: "#AAA0E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.993 170.965C209.692 170.752 209.619 170.341 209.836 170.048C210.038 169.749 210.45 169.682 210.749 169.897C211.035 170.096 211.112 170.51 210.904 170.804C210.693 171.101 210.277 171.167 209.993 170.965Z",
    fill: "#AAA0E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.344 171.836L214.622 167.207L216.438 168.492C217.489 169.237 217.634 170.314 216.989 171.225C216.335 172.149 215.27 172.35 214.203 171.594L213.372 171.006L212.303 172.515L211.344 171.836ZM213.919 170.232L214.597 170.712C215.166 171.115 215.671 170.992 215.998 170.523C216.327 170.065 216.268 169.558 215.702 169.152L215.024 168.672L213.919 170.232Z",
    fill: "#AAA0E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.628 170.751L216.35 175.38L215.404 174.71L218.682 170.081L219.628 170.751Z",
    fill: "#AAA0E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.609 177.085C217.546 176.328 217.381 175.179 218.163 174.081C218.918 173.008 220.093 172.751 221.11 173.471C222.021 174.116 222.333 175.201 221.495 176.384L221.305 176.652L218.933 174.973C218.562 175.497 218.644 176.039 219.13 176.389C219.456 176.614 219.785 176.637 220.025 176.494L220.927 177.133C220.337 177.68 219.468 177.688 218.609 177.085ZM219.354 174.378L220.831 175.424C221.127 174.999 221.051 174.49 220.627 174.194C220.194 173.883 219.656 173.992 219.354 174.378Z",
    fill: "#AAA0E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.612 187.876C218.658 191.851 227.067 192.463 232.407 192.463C236.857 192.221 238.484 190.173 238.334 189.285C238.062 187.674 238.652 186.669 236.337 184.252C234.021 181.836 220.531 173.582 213.988 170.863C207.444 168.145 200.29 166.976 197.578 169.555C195.696 171.345 196.064 174.433 197.578 177.199C198.753 179.346 203.747 184.484 210.612 187.876Z",
    fill: "#17161E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.38 148.402C274.263 155.256 283.182 154.655 287.009 154.655C293.508 154.451 295.655 151.499 295.505 150.611C295.233 149 295.823 147.995 293.508 145.579C291.192 143.163 277.702 134.908 271.158 132.19L271.129 132.177C264.588 129.461 255.811 125.814 253.103 128.39C251.221 130.18 252.067 135.702 253.581 138.468C255.096 141.234 256.901 144.321 263.38 148.402Z",
    fill: "#17161E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.197 143.187C176.023 141.551 174.652 138.174 174.652 135.075C174.811 130.808 175.904 133.562 176.732 133.562C177.561 133.562 179.462 137.113 180.015 140.111C180.567 143.109 193.695 157.652 182.997 149.507C180.213 147.388 178.354 144.798 177.213 143.209L177.197 143.187Z",
    fill: "#17161E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.482 134.185C174.956 144.301 188.729 154.259 195.556 157.974L195.283 146.514C193.023 144.954 187.828 141.881 181.424 136.177C176.302 131.614 174.662 123.478 174.482 119.98V134.185Z",
    fill: "#8D3D02"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.576 157.993L195.293 146.795L197.432 145.242L197.549 156.16L195.576 157.993Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.919 156.164L195.73 148.409L197.104 147.285L197.209 154.996L195.919 156.164Z",
    fill: "#A3A3A3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.919 156.161L195.73 148.406L202.197 152.022L201.287 159.164L195.919 156.161Z",
    fill: "#B66021"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M291.207 144.609C292.034 145.872 292.197 148.874 291.205 151.189",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M292.982 145.746C293.349 146.524 293.863 148.62 292.982 150.781",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M303.473 138.645C304.655 138.852 306.826 140.006 306.055 142.956",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M305.068 140.559C305.37 140.85 305.882 141.872 305.52 143.631",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.914 127.6C306.407 127.359 307.524 126.907 308.054 127.028",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M306.365 126.189C306.606 126.058 307.196 125.796 307.631 125.797",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M302.244 132.204C302.84 132 304.184 131.714 304.797 132.204",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.391 131.386C302.602 131.197 303.372 130.808 304.765 130.77",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M275.412 111.505C275.421 110.64 275.25 108.643 274.488 107.582",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.931 111.358C276.114 110.387 276.266 108.058 275.412 106.512",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M292.221 115.807C292.388 115.062 292.995 113.454 294.089 112.98",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M292.797 116.373C293.014 115.646 293.822 113.994 295.32 113.199",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.497 189.191C242.21 189.396 241.342 189.617 240.162 188.863",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M243.289 188.515C243.014 188.663 242.313 188.815 241.707 188.238",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.307 176.992C248.895 177.095 247.67 177.24 246.074 176.992",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M249.409 176.168C248.974 176.282 247.835 176.443 246.762 176.168",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M242.387 183.285C242.645 183.733 243.426 184.675 244.483 184.857",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.635 182.762C242.787 183.126 243.332 183.887 244.298 184.015",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M223.012 141.138C218.231 140.632 214.271 143.458 212.889 144.934C216.779 157.471 221.974 183.574 222.537 187.455C223.24 192.306 238.153 193.33 242.441 189.393C245.938 186.55 249.21 181.056 249.726 173.828C250.148 167.926 246.633 157.378 241.009 151.05C235.385 144.723 228.987 141.77 223.012 141.138Z",
    fill: "#141414"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.399 143.884C212.327 144.398 212.183 145.715 211.51 146.579C218.028 161.139 230.004 190.113 232.139 190.784C234.807 191.622 240.889 188.003 242.955 181.399C244.812 176.291 243.911 169.279 242.332 164.973C239.282 156.653 233.084 149.613 226.988 146.087C220.776 142.493 215.318 143.656 214.399 143.884Z",
    fill: "#8D3D02"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M212.921 144.574L203.863 150.135C203.779 158.07 205.02 175.409 210.658 181.285C217.705 188.63 223.809 190.267 229.119 191.111C234.429 191.955 237.788 188.243 238.79 187.041L238.819 187.007C240.243 185.299 243.869 180.951 242.708 170.778C239.961 158.104 231.914 150.736 226.319 147.143C221.363 143.96 215.393 143.928 212.921 144.574Z",
    fill: "#DF8654"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M202.277 152.062L195.73 148.409L197.104 147.285L203.567 150.894L202.277 152.062Z",
    fill: "#DFCDBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M258.237 121.581L258.234 106.775L260.089 104.875L260.092 119.83L258.237 121.581Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M194.621 118.708C185.851 123.256 181.478 131.053 182.489 135.231C179.19 131.924 177.979 130.271 177.66 128.728C176.649 125.136 174.713 119.128 179.566 114.211C185.632 108.065 192.945 104.357 203.909 101.769C213.129 99.5915 225.644 98.7618 237.532 100.374C247.197 101.685 255.813 104.677 258.234 106.459V121.436C254.817 120.326 251.516 118.679 235.552 115.247C219.588 111.816 204.978 113.336 194.621 118.708Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 148.546C199.652 149.057 199.323 159.26 199.919 164.407C200.94 170.064 203.741 174.233 206.959 178.109C217.192 189.901 226.61 187.984 228.739 186.872C230.992 185.695 236.455 180.696 234.949 172.282C233.792 165.816 228.247 158.94 225.846 156.5C223.403 154.019 217.019 148.072 208.66 148.546Z",
    fill: "#DF8654"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.944 153.795C199.62 153.941 199.909 162.601 201.22 166.914C204.419 176.286 212.703 182.765 215.983 184.189C219.71 185.807 227.638 185.423 229.512 180.03C231.386 174.636 229.033 169.458 228.589 168.483C228.362 167.984 220.6 153.612 208.944 153.795Z",
    fill: "#8D3D02"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M265.103 112.25L258.557 108.597L259.931 107.473L266.393 111.082L265.103 112.25Z",
    fill: "#DFCDBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M258.746 118.957L258.557 108.598L265.024 112.213L264.113 121.96L258.746 118.957Z",
    fill: "#B66021"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.45 145.239L195.292 146.791C183.237 140.609 177.692 133.285 175.756 128.086C172.149 118.405 177.261 113.575 180.267 110.778C183.73 107.281 193.709 100.487 207.666 98.6762C215.039 97.7197 220.913 97.1531 229.533 97.6562C246.563 98.9282 256.988 102.99 260.079 104.874L258.211 106.789C256.232 105.658 249.083 103.329 245.608 102.544C240.46 101.475 227.67 99.5262 217.691 100.286C205.218 101.237 199.798 102.723 197.422 103.673C195.046 104.623 188.598 106.603 183.331 111.118C178.611 115.164 177.36 117.542 176.993 119.948C175.84 131.923 190.574 141.901 197.45 145.239Z",
    fill: "#DFCDC0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M252.835 129.963C252.723 128.792 253.763 125.156 254.298 123.484L255.9 126.48L263.286 137.837C268.302 140.856 278.391 146.936 278.614 147.103C278.837 147.27 291.619 146.523 297.983 146.128C300.932 143.991 306.58 140.415 305.577 143.201C304.323 146.685 299.028 154.906 283.63 154.279C268.233 153.652 259.927 145.095 256.65 140.673C253.58 136.529 252.974 131.427 252.835 129.963Z",
    fill: "#DF8654"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.315,
    cy: 128.62,
    rx: 28.8611,
    ry: 21.6256,
    transform: "rotate(22.8984 281.315 128.62)",
    fill: "#141414"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M262.881 142.133C263.001 141.341 263.471 139.572 264.392 138.824",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.858,
    cy: 125.02,
    rx: 13.5439,
    ry: 8.23092,
    transform: "rotate(22.8984 281.858 125.02)",
    fill: "#592A10"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.2,
    cy: 126.884,
    rx: 11.5765,
    ry: 7.03533,
    transform: "rotate(22.8984 283.2 126.884)",
    fill: "#141414"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.416 136.656C288.714 141.005 299.205 139.458 301.848 133.2C304.491 126.942 298.286 118.342 287.988 113.993C277.691 109.643 267.2 111.19 264.556 117.449C261.913 123.707 268.118 132.306 278.416 136.656ZM280.466 131.805C286.355 134.293 292.355 133.408 293.867 129.828C295.379 126.249 291.83 121.331 285.94 118.843C280.051 116.355 274.051 117.24 272.539 120.82C271.027 124.399 274.576 129.317 280.466 131.805Z",
    fill: "#8D3D02"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M253.652 126.299C253.956 125.119 255.029 122.552 256.888 121.734",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M254.213 129.045C254.357 127.989 254.939 125.735 256.119 125.16",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M261.982 141.417C262.234 140.122 263.263 137.137 265.363 135.555",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M261.133 140.609C261.2 139.378 261.827 136.687 263.802 135.77",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M278.392 136.715C278.413 137.556 278.238 139.526 277.369 140.677",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M279.199 137.066C279.295 137.407 279.429 138.281 279.199 139.048",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M236.054 146.574C235.692 146.625 234.913 146.889 234.689 147.535",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M235.466 146.094C234.906 146.286 233.671 146.873 233.211 147.678",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M245.652 158.586C245.226 158.716 244.129 159.125 243.146 159.715",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M246.13 159.219C245.803 159.329 245.009 159.654 244.451 160.08",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M220.257 143.564C220.212 143.144 220.359 142.193 221.303 141.742",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M220.795 143.725C220.822 143.412 221.01 142.722 221.546 142.465",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M228.865 147.127C228.99 146.752 229.396 145.974 230.018 145.867",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M237.844 156.191C238.147 155.789 238.953 154.953 239.747 154.824",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M238.057 156.515C238.343 156.229 239.033 155.625 239.504 155.496",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.049 164.787L210.996 161.141L212.366 162.624C213.202 163.529 213.097 164.52 212.342 165.223C211.584 165.917 210.585 165.936 209.744 165.025L209.039 164.262L207.703 165.496L207.049 164.787ZM209.623 163.723L210.237 164.388C210.733 164.92 211.255 164.883 211.672 164.497C212.094 164.107 212.164 163.598 211.671 163.064L211.057 162.398L209.623 163.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.384 168.486C210.168 168.251 210.18 167.881 210.417 167.667C210.643 167.453 211.01 167.473 211.229 167.705C211.436 167.934 211.426 168.301 211.197 168.513C210.963 168.729 210.593 168.712 210.384 168.486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.465 169.568L215.413 165.922L216.783 167.405C217.619 168.31 217.514 169.301 216.758 170.004C216.001 170.699 215.002 170.717 214.161 169.807L213.456 169.043L212.12 170.277L211.465 169.568ZM214.039 168.504L214.654 169.17C215.15 169.701 215.671 169.664 216.089 169.279C216.511 168.889 216.581 168.379 216.088 167.845L215.473 167.18L214.039 168.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.21 170.033L215.263 173.679L214.618 172.982L218.566 169.335L219.21 170.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.031 175.714C216.208 174.823 216.296 173.726 217.223 172.869C218.138 172.023 219.274 172.005 220.054 172.85C220.724 173.576 220.848 174.623 219.809 175.583L219.591 175.784L217.683 173.718C217.188 174.194 217.163 174.768 217.581 175.216C217.86 175.524 218.18 175.607 218.44 175.533L219.07 176.215C218.442 176.563 217.665 176.401 217.031 175.714ZM218.159 173.282L219.451 174.681C219.852 174.305 219.895 173.761 219.525 173.36C219.139 172.943 218.558 172.959 218.159 173.282Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc04);
export default __webpack_public_path__ + "static/media/etc_04.4bbf8dfde3620f6d88a7e670c3937412.svg";
export { ForwardRef as ReactComponent };